import { SvgIcon, SxProps } from "@mui/material";
import SvgCircleCheck from "jsx:../../../Images/Icons/FontAwesome/solid/badge-check.svg";

export function TrustedUserIcon(props: SxProps) {
    return (
        <SvgIcon
            component={SvgCircleCheck}
            inheritViewBox
            sx={{
                color: "var(--community-color-light-steal-blue)",
                height: "12px",
                width: "12px",
                marginLeft: "4px",
                ...props,
            }}
        />
    );
}
